import Analysis from 'models/analysis';
import analysisApi from 'api/analysis';
import AnalysisTabs from 'components/analysisTabs';
import branchApi from 'api/branch';
import Customer from 'models/customer';
import customerApi from 'api/customer';
import dealerApi from 'api/dealer';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import FooterDeleteButton from 'components/layout/footerDeleteButton';
import FooterEditButton from 'components/layout/footerEditButton';
import getProductDict from './productDict';
import Header from 'components/layout/header';
import Loader from 'components/loader';
import moment from 'moment';
import PageFooter from 'components/layout/pageFooter';
import path from 'path';
import Pool from 'models/pool';
import poolApi from 'api/pool';
import productApi from 'api/product';
import ProductProfile from './chemicals';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import SourceTest from './source';
import SystemDetails from './details';
import ValidationGroup from 'helpers/validation';
import waterTesterApi from 'api/waterTester';
import {canDeleteSystems} from 'helpers/dataHelpers';
import {canTest, preprocessData, scanDisabledFields} from 'helpers/scanHelpers';
import {
  chemicalBaseTypeNames,
  chemicalBaseTypes,
  chemicalBaseTypeMinVolumes,
  locationTypes,
  productTypes,
  systemTypes,
  countries,
  optimizerProducts,
} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {isProductTruBlue} from 'helpers/truBlue';
import IntlWrapper from 'components/layout/intlWrapper';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';
import NoteFooter from 'components/notes/NoteFooter';

// imports necessary to support socket scanning interface
import {old_render} from 'page/customer/system/main.jsx';
import {UseHTTPScannerInterface} from 'lib/globals';
import TC from 'services/testConnect2p0';

let old_or_new_render = (container, params) => {
  UseHTTPScannerInterface.then((val) => {
    if(val === true) {
      render(container, params);
    }else{
      old_render(container, params);
    }
  });
};

const poolToSpa = {
  1: 6,
  2: 5,
  3: 8,
  5: 5,
  6: 6,
  7: 5,
  8: 8,
  12: 5,
  13: 5,
};

const spaToPool = {
  1: 1,
  2: 2,
  3: 3,
  5: 2,
  6: 1,
  7: 7,
  8: 3,
  12: 12,
  13: 12,
};

function updateChemicalBaseType(prevTypeID, newTypeID, prevChemicalBaseType) {
  if ((prevTypeID === 1 || prevTypeID === 3) && newTypeID === 2) {
    return poolToSpa[prevChemicalBaseType];
  } else if (prevTypeID === 2 && (newTypeID === 1 || newTypeID === 3)) {
    return spaToPool[prevChemicalBaseType];
  }

  return prevChemicalBaseType;
}

// Register in router
let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');
  let _id;
  let _contactid;

  if (params.id) {
    _id = parseInt(params.id.split('.')[0]);
    _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
  }

  ReactDOM.render(
    <IntlWrapper>
      <WrapperCustomerSystem
        id={_id}
        contactId={_contactid}
        systemID={params.system}
        view={params.view || 'details'}/>
    </IntlWrapper>,
    container);
  events.publish('page-change', {page: 'customer'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id/:system/:view', handler: routeUtils.requireAuth(old_or_new_render)}]);

// Page object
class CustomerSystem extends React.Component {
  static displayName = 'CustomerSystem';

  static propTypes = {
    id: PropTypes.number,
    systemID: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    contactId: PropTypes.number,
  };

  constructor(props) {
    super(props);

    const selectTester = this.props.intl.formatMessage({id: 'scanning.select.tester'});
    const manual = 'Manual';

    this.state = {
      analysis: new Analysis({sourceWaterType: 'City', waterTester: selectTester}),
      analysisModified: false,
      analysisWorkingCopy: new Analysis({sourceWaterType: 'City', waterTester: selectTester}),
      branch: {},
      connected: false,
      customer: new Customer({}),
      customerWorkingCopy: new Customer({}),
      dealer: {},
      detailsExpanded: false,
      edit: false,
      groundLevelSet: false,
      loaded: false,
      manualScan: true,
      noScannersFound: false,
      pool: new Pool({}),
      poolWorkingCopy: new Pool({}),
      productDict: getProductDict({
        pool: new Pool({}), 
        products: [], 
        dealer: {}, 
        formatMessage: () => {},
        customFilter: p => !(p.code === '42665' && p.country === 'CA') // Hide Chlorinating Tabs from ALEX CANADA
      }).productDict,
      products: [],
      sanitizerName: '',
      sanitizerType: 0,
      scanResetDelay: 0,
      saveState: '',
      scannerInitialized: false,
      scanners: [manual],
      scanning: TC.isScanning,
      seasonUsageModified: true,
      selectedScanner: manual,
      testers: [],
      view: this.props.view || 'details',
    };
  }

  componentWillMount() {
    if (this.props.view === 'source' && canTest()) {
      this.fetchSource();
    }

    this.group = new ValidationGroup(this.saveSystem);
  }

  componentDidMount() {
    this.mounted = true;

    this.titrationTestingListener = events.subscribe('dealeruser.toggleTitrationTestingOnly', () => this.initializeScanner());
    if (this.props.view === 'source' && canTest()) {
      this.initializeScanner();

      this.scanStart = events.subscribe('scanner.start', () => this.setState({scanning: true}));
      this.scanCancel = events.subscribe('scanner.cancel', () => {
        if (this.mounted) {
          this.setState({scanning: false});
        }
      });
      this.scanComplete = events.subscribe('scanner.complete', (results) => {
        this.parseScanResults(results);
      });
    }
    this.fetchData();
  }

  componentWillReceiveProps(newProps) {
    // Don't update if it's the same id (i.e. changing pages since this overrides the user's changes)
    if (this.props.id !== newProps.id) {
      this.props = newProps;
      this.fetchData();
    }

    this.props = newProps;

    if (this.props.view === 'source' && canTest()) {
      this.setState({loaded: false});

      this.initializeScanner();

      this.cleanUpEvents();

      this.scanStart = events.subscribe('scanner.start', () => this.setState({scanning: true}));
      this.scanCancel = events.subscribe('scanner.cancel', () => {
        if (this.mounted) {
          this.setState({scanning: false});
        }
      });
      this.scanComplete = events.subscribe('scanner.complete', (results) => {
        this.parseScanResults(results);
      });

      this.fetchSource();
    }

    this.setState({view: this.props.view});
  }

  componentWillUnmount() {
    this.mounted = false;
    this.cleanUpEvents();
    if (!this.state.scanning) {
      //resetTestConnect(false);
      TC.reset();
    }
    if (this.titrationTestingListener && this.titrationTestingListener.remove) {
      this.titrationTestingListener.remove();
    }
  }

  analysisChanged = (e) => {
    let analysisCopy = this.state.analysisWorkingCopy.clone();

    analysisCopy[e.key] = e.value;
    this.setState({
      analysisModified: true,
      analysisWorkingCopy: analysisCopy,
    });
  };

  cancelEdit = () => {
    if (this.props.systemID === 'add-pool') {
      window.location.hash = path.join(window.location.hash, '..', '..');
      return;
    }

    let {productDict, pool} = getProductDict({
      pool: this.state.pool,
      products: this.state.products,
      dealer: this.state.dealer,
      prevPool: this.state.pool,
      formatMessage: this.props.intl.formatMessage,
      customFilter: p => !(p.code === '42665' && p.country === 'CA')
    });

    this.setState({
      edit: false,
      analysisWorkingCopy: this.state.analysis.clone(),
      poolWorkingCopy: pool.clone(),
      productDict,
      pool: pool.clone(),
    });
  };

  changeScanner = (event) => {
    const manual = 'Manual';


    this.setState({
      selectedScanner: event.target.value,
      manualScan: event.target.value === manual,
    });
  };

  cleanUpEvents = () => {
    if (this.scanStart && this.scanStart.remove) {
      this.scanStart.remove();
    }
    if (this.scanComplete && this.scanComplete.remove) {
      this.scanComplete.remove();
    }
    if (this.scanCancel && this.scanCancel.remove) {
      this.scanCancel.remove();
    }
  };

  dataChanged = e => {
    let prevPool = this.state.poolWorkingCopy.clone();
    let poolCopy = this.state.poolWorkingCopy.clone();
    let {formatMessage} = this.props.intl;

    if(poolCopy.chemicalBaseTypeID === chemicalBaseTypes.softswimPool && poolCopy.volume < chemicalBaseTypeMinVolumes[poolCopy.chemicalBaseTypeID]) {
      events.publish('error.user', {message: formatMessage({id: 'products.volume.low'}, {
        product: chemicalBaseTypeNames(poolCopy.typeID, poolCopy.chemicalBaseTypeID, formatMessage),
        volume: chemicalBaseTypeMinVolumes[poolCopy.chemicalBaseTypeID]})});
      return;
    }

    poolCopy[e.key] = e.value;

    if (e.key === 'nickName') {
      poolCopy.nickName = e.value.trim();
    }

    if (e.key === 'nameMaintenanceProgram') {
      poolCopy.isInMaintenance = e.value;
    }

    if (e.key === 'optimizerProductID') {
      poolCopy.usingOptimizerPlus = !!e.value;
    }

    // reset optimimzer product warden id if using optimizer value has been disabled
    if (e.key === 'usingOptimizerPlus' && !e.value) {
      poolCopy.optimizerProductID = null;
    }

    // If switching types set everything to default except the following
    if (prevPool.typeID !== poolCopy.typeID) {
      let newChemicalBaseType;

      if (this.state.dealer.country !== 'CA' || poolCopy.typeID !== 2 ||
        prevPool.typeID !== 1) {
        newChemicalBaseType = updateChemicalBaseType(prevPool.typeID, poolCopy.typeID, prevPool.chemicalBaseTypeID ||
          this.state.productDict.sanitizer.chemicalBaseType);
      } else {
        newChemicalBaseType = 6;
      }

      console.log('asd1');
      console.log(this.state.products);
      // Calculate once to get product dict to find new sanitizers; calculate again at bottom to update all products properly
      let {productDict} = getProductDict({
        pool: poolCopy,
        products: this.state.products,
        dealer: this.state.dealer,
        prevPool: prevPool,
        formatMessage: this.props.intl.formatMessage,
        customFilter: p => !(p.code === '42665' && p.country === 'CA'),
      });

      let sanitizer = productDict.sanitizer.current;

      if (productDict && productDict.sanitizer && productDict.sanitizer.chemicalBaseType !== newChemicalBaseType) {
        let nextSan = productDict.sanitizer.products.find(x => x.chemicalBaseTypeID === newChemicalBaseType);

        sanitizer = nextSan && nextSan.id ? nextSan.id : sanitizer;
      }

      poolCopy = new Pool({
        id: poolCopy.id,
        customerID: poolCopy.customerID,
        typeID: poolCopy.typeID,
        volume: poolCopy.volume,
        location: poolCopy.location,
        property: poolCopy.property,
        nickName: poolCopy.nickName,
        installedByDealer: poolCopy.installedByDealer,
        chemicalBaseTypeID: newChemicalBaseType,
        finish: poolCopy.typeID !== 1 ? 'A' : 'U',
        sanitizer,
        seasonEnd: this.state.dealer.seasonClose,
        seasonStart: this.state.dealer.seasonOpen,
        isInMaintenance: this.isInMaintenance,
      });

      if (newChemicalBaseType === 7 || newChemicalBaseType === 12) {
        poolCopy.idealSaltPPM = prevPool.idealSaltPPM;
      }

      if (poolCopy.typeID === 3) {
        poolCopy.enzymes = prevPool.enzymes;
      }

      // Default to different dates when pool type is spa
      if (poolCopy.typeID === systemTypes.spa) {
        poolCopy.seasonStart = moment('01 01', 'MM DD');
        poolCopy.seasonEnd = moment('12 31', 'MM DD');
      } else if (poolCopy.location === locationTypes.indoor) {
        // Defaulting dates for pools and swimspas with indoor location
        poolCopy.seasonStart = moment('01 01', 'MM DD');
        poolCopy.seasonEnd = moment('12 31', 'MM DD');
      }

    }

    if (e.key === 'typeID' && parseInt(e.value) === systemTypes.spa) {
      poolCopy.finish = 'A';
      poolCopy.usingOptimizerPlus = false;
    } else if (e.key === 'typeID' && !poolCopy.id) {
      poolCopy.usingOptimizerPlus = true;
    }

    // Default to different dates when pool or swimspa is indoor
    let seasonUsageModified = this.state.seasonUsageModified;

    if (e.key === 'location' && !seasonUsageModified && (poolCopy.typeID === systemTypes.pool || poolCopy.typeID === systemTypes.swimspa)) {
      if (e.value === locationTypes.indoor) {
        poolCopy.seasonStart = moment('01 01', 'MM DD');
        poolCopy.seasonEnd = moment('12 31', 'MM DD');
      }
      if (e.value === locationTypes.outdoor) {
        poolCopy.seasonEnd = this.state.dealer.seasonClose;
        poolCopy.seasonStart = this.state.dealer.seasonOpen;
      }
    }

    if (e.key === 'seasonStart' || e.key === 'seasonEnd') {
      seasonUsageModified = true;
    }

    // Fields must be true if pool is swimspa
    if (e.key === 'typeID' && parseInt(e.value) === systemTypes.swimspa) {
      poolCopy.cannotVacToWaste = true;
      poolCopy.jettedReturns = true;
    }

    let groundLevelSet =
      this.state.groundLevelSet ||
      poolCopy.groundLevel !== this.state.poolWorkingCopy.groundLevel;

    // Automatically set the pool ground level based on volume, unless the
    // ground level has been manually set
    if (!groundLevelSet && poolCopy.volume && !prevPool.volume && poolCopy.typeID !== systemTypes.spa ||
      !poolCopy.groundLevel && poolCopy.typeID === systemTypes.pool) {

      if (this.state.dealer.country === 'CA' && poolCopy.volume <= 9500 || poolCopy.volume <= 3500 && poolCopy.volume >= 500) {
        poolCopy.groundLevel = 'S';
      } else if (poolCopy.volume > 3500) {
        poolCopy.groundLevel = 'I';
      }

      if (!poolCopy.groundLevel) {
        poolCopy.groundLevel = 'I';
      }
    }

    // If ground level leaves splasher range reset
    if ((this.state.dealer.country === 'CA' && poolCopy.volume > 10000 || this.state.dealer.country !== 'CA' && poolCopy.volume > 3500) &&
      poolCopy.groundLevel === 'S') {
      poolCopy.groundLevel = 'I';
    }

    // Clear pH buffer for softsoak trio so can't recommend spa sentry
    if (e.key === 'softSoakTRIO' && e.value) {
      poolCopy.pHBuffer = undefined;
    }

    //Avoid spaComplete recommendation when Natural Enzyme is checked on spas.
    if(e.key === 'spaComplete' && e.value && poolCopy.typeID === systemTypes.spa) {
      poolCopy.enzymes = false;
    }

    if(e.key === 'sanitizer' && this.state.dealer.country === 'CA' && poolCopy.typeID === systemTypes.spa &&
      this.state.productDict && !!this.state.productDict.sanitizer.products.find(p => p.id === e.value && p.chemicalBaseTypeID === chemicalBaseTypes.synergySpa)) {
      poolCopy.softSoakTRIO = false;
    }

    let {productDict, pool} = getProductDict({
      pool: poolCopy,
      products: this.state.products,
      dealer: this.state.dealer,
      prevPool: prevPool,
      formatMessage: this.props.intl.formatMessage,
      customFilter: p => !(p.code === '42665' && p.country === 'CA')
    });

    //If usingOptimizerPlus has been enabled after productDict operations and optimizer type has not been selected for a US pool, default to optimizer
    if(pool.usingOptimizerPlus && !pool.optimizerProductID && this.state.dealer.country === countries.US) {
      pool.optimizerProductID = optimizerProducts.optimizer;
    }

    if (productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.softswimPool) {
      pool.ionization = false;
      pool.ozonator = false;
    }

    pool.synergyClean = productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.synergySpa;

    //Turn off optimizer plus when a Synergy pool on CA is selected.
    if(e.key === 'sanitizer' && this.state.dealer.country === countries.CA && productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.synergyPool) {
      pool.usingOptimizerPlus = false;
      pool.optimizerProductID = null;
    }

    this.setState({
      poolWorkingCopy: pool,
      productDict: productDict,
      seasonUsageModified,
      groundLevelSet,
    });
  };

  deletePool = () => {
    poolApi.deletePool(this.state.pool)
      .then(() => {
        window.location.hash = path.join(window.location.hash, '..', '..');
      })
      .catch(err => {
        console.error(err);
        let {formatMessage} = this.props.intl;

        events.publish('error.user', {message: formatMessage({id: 'general.error.deleting.pool'})});
      });
  };

  editTruBlueState = (newPool, newProductDict) => {
    this.setState({
      poolWorkingCopy: newPool,
      productDict: newProductDict,
      edit: true,
    });
  };

  fetchData = () => {
    let apis = [];

    const defaultTester = this.props.intl.formatMessage({id: 'scanning.select.tester'});

    apis.push(customerApi.getCustomer(parseInt(this.props.id)));
    apis.push(dealerApi.getDealer(session.getUser().dealerId));
    apis.push(productApi.getProducts());
    apis.push(waterTesterApi.getWaterTesters());

    if (this.props.systemID !== 'add-pool') {
      apis.push(poolApi.getPool(parseInt(this.props.systemID), true));

      Promise.all(apis).then(([customer, dealer, products, testers, pool]) => {
        console.log(products);
        // Add a blank water tester
        let a = this.state.analysisWorkingCopy.clone();

        testers = testers || [];

        if (testers.length && testers[0].key !== -1) {
          testers = [{key: -1, name: defaultTester}]
            .concat(testers);
        }
        // Let the default water tester be blank
        if (!a || !a.id) {
          a.waterTester = defaultTester;
        }

        let {productDict, pool: p} = getProductDict({pool, products, dealer, formatMessage: this.props.intl.formatMessage, customFilter: p => !(p.code === '42665' && p.country === 'CA')});

        branchApi.getBranch(customer.branchID)
          .then(branch => {
            this.setState({
              analysisWorkingCopy: a,
              branch: branch,
              customer: customer,
              dealer: dealer,
              loaded: true,
              pool: p.clone(),
              poolWorkingCopy: p.clone(),
              productDict: productDict,
              products: products,
              sanitizerName: productDict.sanitizer.currentName,
              sanitizerType: productDict.sanitizer.chemicalBaseType,
              testers: testers,
            });
          });
      })
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: <FormattedMessage id='error.data.generic' />});
        });
    } else {
      Promise.all(apis).then(([customer, dealer, products, testers]) => {
        testers = testers || [];
        // Add a blank water tester
        let a = this.state.analysisWorkingCopy.clone();

        if (testers.length && testers[0].key !== -1) {
          testers = [{key: -1, name: defaultTester}].concat(testers);
        }
        // Let the default water tester be blank
        if (!a || !a.id) {
          a.waterTester = defaultTester;
        }

        let _pool = this.state.poolWorkingCopy.clone();

        if (!_pool.customerID) {
          _pool = new Pool({
            customerID: this.props.id,
            filterMedia: 'Sand',
            finish: 'U',
            groundLevel: 'I',
            location: 'O',
            property: 'R',
            usingOptimizerPlus: true,
            seasonEnd: dealer.seasonClose,
            seasonStart: dealer.seasonOpen,
            typeID: systemTypes.pool,
            poolOpeningComplete: true,
            optimizerProductID: dealer.country ===  countries.US ? optimizerProducts.opttimizer : null, // For US default borate products to Optimizer choice
            balanceComplete:  dealer.balanceComplete,
          });
        }
        let {productDict, pool} = getProductDict({pool: _pool, products, dealer, formatMessage: this.props.intl.formatMessage, customFilter: p => !(p.code === '42665' && p.country === 'CA')});

        branchApi.getBranch(customer.branchID)
          .then(branch => {
            this.setState({
              analysisWorkingCopy: a,
              branch: branch,
              customer: customer,
              dealer: dealer,
              edit: true,
              loaded: true,
              pool: pool.clone(),
              poolWorkingCopy: pool.clone(),
              productDict: productDict,
              products: products,
              seasonUsageModified: false,
              testers: testers,
            });
          });
      })
        .catch(err => {
          console.error(err);
          let {formatMessage} = this.props.intl;

          events.publish('error.user', {message: formatMessage({id: 'notes.error.retrieve.data'})});
        });
    }
  };

  fetchSource = () => {
    const defaultTester = this.props.intl.formatMessage({id: 'scanning.select.tester'});

    if (this.props.systemID === 'add-pool') {
      let analysis = new Analysis({
        sourceWaterType: 'City',
        waterTester: this.state.analysisWorkingCopy ? this.state.analysisWorkingCopy.waterTester || defaultTester : defaultTester,
      });

      this.setState({
        analysis: analysis,
        analysisWorkingCopy: analysis.clone(),
        loaded: true,
      });
    } else {
      analysisApi.getSourceWater(parseInt(this.props.systemID))
        .then(analysis => {
          if (!analysis.sourceWaterType) {
            analysis.sourceWaterType = 'City';
            analysis.waterTester = analysis.waterTester ? analysis.waterTester || defaultTester : defaultTester;
          }
          this.setState({
            analysis: analysis,
            analysisWorkingCopy: analysis.clone(),
            loaded: true,
          });
        })
        .catch(err => {
          console.error(err);
          let {formatMessage} = this.props.intl;

          events.publish('error.user', {message: formatMessage({id: 'notes.error.retrieve.data'})});
        });
    }
  };

  initializeScanner(preferManual = false) {
    if (session.getUser().titrationTestingOnly) {
      const manual = 'Manual';

      this.setState({
        scannerInitialized: true,
        selectedScanner: manual,
        noScannersFound: false,
      });
      return;
    }

    TC.getStatus()
      .then(data => {
        let disabledFields = [];

        if (TC.isScanning) {
          if (TC.isSmartLabCurrentScanner) {
            disabledFields = scanDisabledFields.SmartLab;
          }
        }

        let selectedScanner = TC.currentScanner || data.scanners[0];

        const manual = 'Manual';

        this.setState({
          disabledFields: disabledFields,
          manualScan: preferManual || selectedScanner === manual,
          noScannersFound: data.scanners.length === 1,
          scannerInitialized: true,
          scanners: data.scanners,
          scanning: TC.isScanning,
          securityError: undefined,
          selectedScanner: preferManual ? manual : selectedScanner,
        });
      });
  }

  parseScanResults = (data) => {
    this.setState({
      disabledFields: [],
      scanning: TC.isScanning,
      analysisWorkingCopy: preprocessData(data, this.state.analysisWorkingCopy, TC.currentScanner, this.state.sanitizerType),
    });
  };

  saveSystem = () => {
    let pool = this.state.poolWorkingCopy.clone();
    let {dealer, products, productDict} = this.state;

    let {formatMessage} = this.props.intl;
    let poolChemicalBaseType = productDict.sanitizer.chemicalBaseType;
    let isSanitizerTruBlue = isProductTruBlue(products, productTypes.sanitizer, dealer, poolChemicalBaseType, pool.sanitizer);
    let isMaintOxidizerTruBlue = isProductTruBlue(products, productTypes.maintOxidizer, dealer, poolChemicalBaseType, pool.maintOxidizer);
    let isPrevAlgicideTruBlue = isProductTruBlue(products, productTypes.prevAlgicide, dealer, poolChemicalBaseType, pool.prevAlgicide);
    let isMaintClarifierTruBlue = isProductTruBlue(products, productTypes.maintClarifier, dealer, poolChemicalBaseType, pool.maintClarifier);

    //Canada SaltWater Pool doesn't evaluate Optimizer plus.
    let countryPoolValidation =  (poolChemicalBaseType === chemicalBaseTypes.saltWaterPool || poolChemicalBaseType === chemicalBaseTypes.synergyPool) && isMaintClarifierTruBlue;

    pool.hasAllTruBlueProducts = isSanitizerTruBlue && isMaintOxidizerTruBlue && isPrevAlgicideTruBlue && countryPoolValidation;

    if(pool.chemicalBaseTypeID === chemicalBaseTypes.softswimPool && pool.volume < chemicalBaseTypeMinVolumes[pool.chemicalBaseTypeID]) {
      events.publish('error.user', {message: formatMessage({id: 'products.volume.low'}, {
        product: chemicalBaseTypeNames(pool.typeID, pool.chemicalBaseTypeID, formatMessage),
        volume: chemicalBaseTypeMinVolumes[pool.chemicalBaseTypeID]})});
      return;
    }

    if (pool.isTruBlueActive === true &&
      (!isSanitizerTruBlue ||
        !isMaintOxidizerTruBlue ||
        !isPrevAlgicideTruBlue ||
        !isMaintClarifierTruBlue)) {
      pool.truBlueExpiry = moment().subtract(1, 'day'); // Not active tru blue
      events.publish('warn.user', {message: formatMessage({id: 'system.status.was.changed'})});
    }

    if (this.state.saveState === 'saving') {
      return; // User has double clicked
    }

    this.setState({saveState: 'saving'});

    let apis = [
      poolApi.savePool(pool),
    ];

    if (this.state.analysisModified) {
      apis.push(analysisApi.saveAnalysis(this.state.analysisWorkingCopy, this.state.customer.id));
      TC.reset();
      //resetTestConnect(!session.getUser().titrationTestingOnly);
    }

    Promise.all(apis)
      .then(([newPool, analysis]) => {
        // socket.cleanup();
        if (this.props.systemID === 'add-pool') {
          window.location.hash = window.location.hash.replace('add-pool', newPool.id.toString());
        }

        let newState = {
          edit: false,
          pool: newPool,
          poolWorkingCopy: newPool,
          saveState: 'saved',
        };

        if (analysis) {
          newState.analysis = analysis;
          newState.analysisWorkingCopy = analysis.clone();
        }

        this.setState(newState);

        //Clear saved pool analysis object to allow for changes
        session.forgetAnalysis(newPool.id);
        events.publish('note.populate.modal');
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: formatMessage({id: 'general.system.not.saved'})});
      });
  };

  startEdit = () => {
    let poolWorkingCopy = this.state.pool.clone();

    this.setState({edit: true, poolWorkingCopy: poolWorkingCopy});
  };

  startScan = (selectedScanner, selectedStrips, chemicalBaseTypeID) => {
    TC.startSmartLab(chemicalBaseTypeID);
    this.setState({scanning: true, disabledFields: scanDisabledFields.SmartLab});
    events.publish('ga.event', {category: 'Scan', action: 'Spin'});

    window.scrollTo(0, 0);
  };

  switchView = (target) => {
    window.location.hash = path.join(window.location.hash, '..', target);
  };

  toggleSystemDetails = () => {
    this.setState({detailsExpanded: !this.state.detailsExpanded});
  };

  render() {
    if (this.state.securityError) {
      return (
        <div className='container'>
          <h3><FormattedMessage id="scanning.complete.water.test"/></h3>
          <br/>
          <p><a className='btn btn-default'
                href='#support/ie-security-error'><FormattedMessage id="general.click.troubleshoot"/></a></p>
        </div>
      );
    }

    let {formatMessage} = this.props.intl;
    let contact = null;
    let contactName = 'Customer';

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }

      contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;
    }

    let subTitle = this.state.poolWorkingCopy.softSoakTRIO ? 'Trio ' : '';

    subTitle += chemicalBaseTypeNames(this.state.poolWorkingCopy.typeID, this.state.poolWorkingCopy.chemicalBaseTypeID || 2, formatMessage);

    let tagLine = this.state.poolWorkingCopy.nickName ? this.state.poolWorkingCopy.nickName.trim() : '';

    let alexProdID = this.state.customer && this.state.customer.accountNum ? <div className='heading-alexid'>
      <span className='heading-alexid-title'><FormattedMessage id='general.alexid'/>:</span> {this.state.customer.accountNum}
    </div> : null;

    let {dealer} = this.state;

    //Generate customer id for url purpose
    let customerUrl = this.props.id.toString();

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    return (
      <div id='customer-systems'>
        <Loader loaded={this.state.loaded}>
          <div className='container'>
            <Header mainTitle={contactName}
                    mainTitleReturn={'customer/' + customerUrl}
                    subTitle={subTitle}
                    tagLine={tagLine}
                    children={alexProdID}>
            </Header>
            <AnalysisTabs systemPath={path.join(location.hash, '..')}
                          canSwitch={this.group._validate}
                          disabled={this.props.systemID === 'add-pool' ? ['analysis', 'report-history'] : []}/>
          </div>

          <SystemDetails
            condition={this.state.view === 'details'}
            dataChanged={this.dataChanged}
            dealer={this.state.dealer}
            detailsExpanded={this.state.detailsExpanded}
            edit={this.state.edit}
            group={this.group}
            pool={this.state.poolWorkingCopy}
            productDict={this.state.productDict}
            systemID={this.props.systemID}
            toggleSystemDetails={this.toggleSystemDetails}
          />

          <ProductProfile
            branch={this.state.branch}
            condition={this.state.view === 'chemicals'}
            customer={this.state.customer}
            dataChanged={this.dataChanged}
            dealer={this.state.dealer}
            edit={this.state.edit}
            editTruBlueState={this.editTruBlueState}
            group={this.group}
            pool={this.state.poolWorkingCopy}
            poolWorkingCopy={this.state.poolWorkingCopy}
            productDict={this.state.productDict}
            products={this.state.products}
            ref={r => this.chemicals = r}
          />

          <SourceTest
            analysis={this.state.analysisWorkingCopy}
            condition={this.state.view === 'source'}
            dataChanged={this.analysisChanged}
            edit={this.state.edit}
            group={this.group}
            pool={this.state.poolWorkingCopy}
            poolChanged={this.dataChanged}
            sanitizerName={this.state.sanitizerName}
            testers={this.state.testers}/>

        </Loader>

        <PageFooter>
          {this.state.customer.id ? <NoteFooter customer={this.state.customer} pool={this.state.pool} /> : null}
          {canDeleteSystems(session.getUser().privileges, dealer) ?
            <FooterDeleteButton onDelete={this.deletePool}
                                enabled={this.props.systemID !== 'add-pool'}/> :
            ''}
          <FooterEditButton onEdit={this.startEdit}
                            onCancel={this.cancelEdit}
                            onSave={this.group.validate}
                            editMode={this.state.edit}/>
        </PageFooter>
      </div>);
  }
}

const WrapperCustomerSystem = bindLocaleUpdate(injectIntl(CustomerSystem));

export default WrapperCustomerSystem;
